// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"vZ-z","sponsoredTooltipWrapper":"wZ-z","sponsoredTooltip":"xZ-z","newCard":"yZ-z"};